export const production = true;
export const mock = false;
// 调试
var server = production
  ? "https://www.xhg.wholehealth.com.cn/manage"
  : "https://127.0.0.1:8084/manage"
//export const basisURL = "https://" + server;

//:"www.guicanggu.com/manage/test";
//? "https://xhg.wholehealth.com.cn/manage"
export const basisURL = server;

